import { PortalConnection } from 'vet-bones/utils/portal';

import { Permission } from 'src/constants/permissions';

export const enum ConnectionStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  SIGNED_OUT = 'SIGNED_OUT',
}

export enum ConnectionFailureReason {
  NO_RESPONSE = 'NO_RESPONSE',
}

export interface Connection extends PortalConnection {
  // username always exists
  username: string;
  // password could exist
  password?: string;
  token?: string;
}

/** convert a Portal Connection into a Designer Connection */
export const coercePortalConnection = (
  connection: PortalConnection
): Connection => ({
  ...connection,
  // assuming username is never undefined
  username: connection.username || '',
  // convert from `null | undefined` to just `undefined`
  token: connection.token || undefined,
});

export type ConnectionsState = {
  authenticatedUsername: string | null;
  catalogDatabaseByConnectionId: Record<string, string>;
  connection: Connection | null;
  failureReason: ConnectionFailureReason | null;
  featureVersionByConnectionId: Record<string, string | null>;
  pendingConnectToStardog: boolean;
  permissions: Permission[] | null;
  /** We couldn't read them: lookup failed, or no username to look up by. */
  permissionsUnavailable: boolean;
  querylogDatabaseByConnectionId: Record<string, string>;
  stardogVersionByConnectionId: Record<string, string | null>;
  status: ConnectionStatus | null;
  voiceboxDbLimitByConnectionId: Record<string, number>;
};

export const createInitialConnectionsState = (): ConnectionsState => ({
  authenticatedUsername: null,
  catalogDatabaseByConnectionId: {},
  connection: null,
  failureReason: null,
  featureVersionByConnectionId: {},
  pendingConnectToStardog: false,
  permissions: null,
  permissionsUnavailable: false,
  querylogDatabaseByConnectionId: {},
  stardogVersionByConnectionId: {},
  status: null,
  voiceboxDbLimitByConnectionId: {},
});
